const keywords =
  "app tv, new braz, new hybrid, xcloud tv, dream tv, IPTV Smarters Pro, TiviMate, IBO Player, Kodi, UNITV, Now, PixelPlay, AlphaPlay, Warez, Five, Mundo GF Rboys, Mundo GF DNA go, P2Braz, Horizon, Fast, Blade, UniPlay, Global, FireTv, Club, NewTVs, RushPlay, Genial Play, Neko, Seven, Live21, Xplay, Power, P2Cine, BrPro, AlphaServer, Bestflix, Blaze, BlackBr, Zeus, GranFlix, iMPerial, 4k-Pro, Epic, Btv, Production, NetPlay, Top Z, Veloz, purple iptv, isp iptv, vejo v3, p2p brasil, melhor p2p 2026";

export const Footer = () => (
  <footer data-testid="site-footer" className="py-14 px-4 sm:px-6 border-t border-white/10">
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-6 mb-10">
        <div className="flex items-center gap-2">
          <img src="/assets/newbraz.png" alt="New Braz logo" className="w-8 h-8 rounded-lg object-contain" />
          <span className="text-xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>
            New <span className="text-[#FF5A00]">Braz</span>
          </span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/50">
          <a href="#beneficios" className="hover:text-white transition-colors">Benefícios</a>
          <a href="#planos" className="hover:text-white transition-colors">Planos</a>
          <a href="#downloads" className="hover:text-white transition-colors">Downloads</a>
          <a href="#dispositivos" className="hover:text-white transition-colors">Dispositivos</a>
          <a href="#faq" className="hover:text-white transition-colors">FAQ</a>
        </nav>
      </div>

      <div data-testid="seo-keywords" className="border-t border-white/5 pt-8 mb-8">
        <h2 className="text-xs font-semibold text-white/30 mb-2 uppercase tracking-wider" style={{ fontFamily: "Manrope, sans-serif" }}>
          Aplicativos e serviços compatíveis
        </h2>
        <p className="text-xs text-white/20 leading-relaxed">
          New Braz é a melhor alternativa para quem busca: {keywords}. Assista filmes, séries e canais ao vivo
          em 4K no seu app tv favorito com a melhor estabilidade do Brasil.
        </p>
      </div>

      <p className="text-center text-xs text-white/35">© 2026 New Braz. Todos os direitos reservados.</p>
    </div>
  </footer>
);
